export const createAdminSlice = (set) => ({
  user: undefined,
  setUser: (user) => set(() => ({ user })),
  sidebarOpen: false,
  setSidebarOpen: (isOpen) => set(() => ({ sidebarOpen: isOpen })),
});
